import type { MRT_Row } from 'material-react-table'
import { observer } from 'mobx-react-lite'
import type { Stores } from '../../../../util/store'
import type { MouseEvent } from 'react'
import { useModelsById } from '../../../../stores/models-store'
import type { WOManufacturerMatchStore } from '../wo-manufacturer-match/wo-manufacturer-match-store'
import { useResolvedManufacturerAlias } from '../wo-manufacturer-match/wo-manufacturer-match-store'
import { useManufacturerById } from '../../../../stores/manufacturers-store'
import styles from './registered-model-cell.module.scss'
import { ModelsModalState } from './types'
import { APIModelAliasReference } from '@visorpro/client'

export interface RegisteredModelCellProps {
    row: MRT_Row<APIModelAliasReference>
    manufacturersStore: WOManufacturerMatchStore
    stores: Stores
    onOpen(e: MouseEvent, input: ModelsModalState): void
}

export const RegisteredModelCell = observer<RegisteredModelCellProps>(
    ({ row, stores, onOpen, manufacturersStore }) => {
        const modelIds = row.original.product_model_ids
        const models = useModelsById(stores, new Set(modelIds))
        const aliasId = row.original.alias_id
        const inputModelName = row.original.input_model
        const manufacturerAlias = useResolvedManufacturerAlias(
            row.original,
            manufacturersStore,
        )
        const manufacturer = useManufacturerById(
            manufacturerAlias?.product_manufacturer_id,
            stores,
        )
        const inputManufacturerName = row.original.input_manufacturer

        if (aliasId && models.length) {
            return (
                <div className={styles.container}>
                    {models.map((model) => {
                        return (
                            <span
                                key={model.id}
                                onClick={(e) => {
                                    onOpen(e, {
                                        alias_id: aliasId,
                                        model_ids: modelIds,
                                        input_model_name: inputModelName,
                                        input_manufacturer_name:
                                            inputManufacturerName,
                                        manufacturer_id: manufacturer?.id,
                                    })
                                }}
                                className={styles.pill}>
                                {model.name}
                            </span>
                        )
                    })}
                </div>
            )
        }

        return (
            <div>
                <button
                    onClick={(e) => {
                        onOpen(e, {
                            alias_id: aliasId,
                            model_ids: modelIds,
                            input_model_name: inputModelName,
                            input_manufacturer_name: inputManufacturerName,
                            manufacturer_id: manufacturer?.id,
                        })
                    }}
                    className={styles.searchButton}>
                    search
                </button>
            </div>
        )
    },
)
